const NOTIFICATION_LABEL_TEXT = 'Você será notificado em:';
const EDIT_DESTINATION_INFO_BUTTON_ID = 'success-btn-edit-destination-info';

const WARNING_TITLE = 'Eita!';
const WARNING_PROBLEM_DESCRIPTION =
  'Algo deu errado por aqui, mas você pode tentar novamente e acessar as informações da sua entrega.';
const WARNING_BUTTON_VALUE = 'Quero tentar';

export {
  NOTIFICATION_LABEL_TEXT,
  WARNING_TITLE,
  WARNING_PROBLEM_DESCRIPTION,
  WARNING_BUTTON_VALUE,
  EDIT_DESTINATION_INFO_BUTTON_ID
};
